import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { xs, sm, md } = constants.breakpoints.BreakpointNames;
const { ui } = constants.colors;

const neutral700 = ui.neutral[700];
const neutral600 = ui.neutral[600];
const neutral400 = ui.neutral[400];
const neutral200 = ui.neutral[200];
const white = ui.white[500];

export const contentWrapper = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "left",
  color: neutral700,
  background: "#FFF",
  padding: "16px",
  gap: "40px",
  [mq.downTo(xs)]: {
    padding: "40px",
  },
  [mq.downTo(md)]: {
    padding: "10px 80px",
  },
};

export const headerCss = {
  width: "100%",
  display: "flex",
};

export const titleCss = {
  color: "var(--neutrals-dark-grey-700, #1D1D1D)",
  textAlign: "center",
  margin: "0px",
  /* Headings/Circular/Heading 2 */
  fontFamily: "Circular",
  fontSize: "32px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "125%" /* 40px */,
};

export const subTitleCss = {
  color: neutral700,
  textAlign: "center",
  textTransform: "uppercase",
  margin: "0px",
  fontFamily: "Circular",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "125%",
};

export const textCss = {
  color: neutral700,
  textAlign: "center",
  marginTop: "0px",
  /* Text/Text M */
  fontFamily: "Circular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "150%" /* 24px */,
  [mq.downTo(sm)]: {
    width: "50%",
  },
};

export const widgetsWrapper = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "8px",
  width: "100%",
  flex: 1,
  "& > :nth-child(n)": {
    flex: 1,
  },
};

export const widgetsGroup = {
  display: "flex",
  // flexWrap: 'wrap',
  flexDirection: "column",
  gap: "8px",
  minWidth: "174px",
};

export const widgetsAvgGroup = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(49.3%, 1fr))",
  gridGap: "8px",
  width: "100%",
  flex: 1,
  "& > :nth-child(n)": {
    maxWidth: "100%",
  },
};

export const smallCss = {
  color: neutral700,
  fontFamily: "Circular",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "125%",
};

export const leftWidgetCss = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
};

export const studentsHeader = {
  display: "flex",
  justifyContent: "space-between",
  color: neutral600,
  fontFamily: "Circular",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "133%" /* 15.96px */,
  letterSpacing: "1px",
  textTransform: "uppercase",
  padding: "0px 8px",
  minWidth: "250px",
  [mq.downTo(xs)]: {
    minWidth: "308px",
  },
};

export const studentRowWrapper = {
  display: "flex",
  justifyContent: "space-between",
  background: white,
  borderRadius: "8px",
  marginBottom: "8px",
  padding: "8px",
};

export const studentRowNameWrapper = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

export const studentRowTokensWrapper = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

export const studentRowName = {
  overflow: "hidden",
  color: neutral600,
  textOverflow: "ellipsis",
  fontFamily: "Circular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "150%" /* 24px */,
  margin: 0,
  letterSpacing: 0,
};

export const studentRowTokens = {
  margin: 0,
};

export const studentRowNameNumber = {
  margin: 0,

  fontFamily: "Noto Serif",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "133%" /* 24px */,
};

export const topicHeader = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  color: neutral600,
  textAlign: "left",
  fontFamily: "Circular",
  textOverflow: "ellipsis",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "133%" /* 15.96px */,
  letterSpacing: "1px",
  padding: "0px 8px",
  minWidth: "208px",
  height: "100%",
  p: {
    marginTop: 0,
    letterSpacing: 0,
  },
  [mq.downTo(sm)]: {
    minWidth: "308px",
  },
};

export const topicsList = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "180px",
  flex: 1,
};

export const topicRowWrapper = {
  display: "flex",
  justifyContent: "space-between",
  background: white,
  borderRadius: "8px",
  marginBottom: "8px",
  padding: "8px",
  flex: 1,
  maxHeight: "112px",
};

export const topicRowLeftWrapper = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

export const topicRowTextWrapper = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
};

export const topicRowName = {
  overflow: "hidden",
  color: neutral700,
  textOverflow: "ellipsis",
  fontFamily: "Circular",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "150%" /* 24px */,
  margin: 0,
  letterSpacing: 0,
};

export const topicRowSubtextWrapper = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "& > :first-child": {
    paddingRight: "8px",
    borderRight: `1px solid ${neutral200}`,
  },
};

export const topicRowSubtext = {
  overflow: "hidden",
  color: neutral400,
  textOverflow: "ellipsis",
  fontFamily: "Circular",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "133%" /* 24px */,
  margin: 0,
  letterSpacing: 0,
};

export const topicRowNameNumber = {
  margin: 0,
  height: "100%",
  fontFamily: "Noto Serif",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "133%" /* 24px */,
};

export const avgWidgetWrapper = {
  display: "flex",
  alignItems: "center",
  gap: "24px",
  padding: "0px",
};

export const avgLeftWrapper = (percentage, strokeWidth = 6) => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "50%",
    height: "138px",
    width: "138px",
    position: "relative",
    overflow: "hidden", // Ensure content inside the circle is not visible outside the border
    background: `
      radial-gradient(circle at center, #CCE1FF ${
        50 - strokeWidth / 2
      }%, transparent ${50 - strokeWidth / 2}%, transparent ${
        50 + strokeWidth / 2
      }%, #CCE1FF ${50 + strokeWidth / 2}%),
      conic-gradient(${neutral600} 0% ${percentage}%, rgb(29, 29, 29,.2) ${percentage}% 100%)
    `,
  };
};

export const avgRightWrapper = {
  display: "flex",
  flexDirection: "column",
  textAlign: "start",
  gap: "8px",
  maxWidth: "50%",
};

export const avgWidgetScholl = {
  color: neutral700,
  margin: "0px",
  /* Text/Text M */
  fontFamily: "Circular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "150%" /* 24px */,
};

export const avgTotalPercentageCss = {
  color: neutral700,
  margin: "0px",
  /* Text/Text M */
  fontFamily: "Circular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "150%" /* 24px */,
};

export const avgTotalPercentageStrongCss = {
  fontSize: "40px",
  lineHeight: "120%" /* 24px */,
};

export const badgeCss = {
  padding: "8px",
  maxWidth: "fit-content",
};

export const noDataAvailableCss = {
  fontSize: "12px",
  fontStyle: "italic",
  height: "100%",
};
